import AppointmentPinV2 from './AppointmentPinV2';

export default AppointmentPinV2;
